import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { SiteModel, TenantsModel } from ".";

export class ContractModel {
    public Id: number;
    public ContractNo: string;
    public LegalHolderId: number;
    public SiteId: number;
    //public OpponentHolderId : number;
    public OpponentHolder: string;
    public ValidFrom: Date;
    public ValidTo: Date;
    public RemindDate: Date;
    public CancelLatest: Date;
    public Active: boolean;
    public Note: string = "";
    public FileDir: string;
    public ChangedBy: string;
    public ChangedTime: Date;
    public CategoryId: number;
    public AmountYearly: number;
    public InformationText: string;
    public AmountYearlyDK: number;
    public PostPoneMonths: number;

    public LegalHolder: LegalHolderModel;
    //public Opponent :OpponentModel;
    public Category: ContractCategoryModel;
    public Site: SiteModel;

    public ValidFromModel: NgbDateStruct;
    public ValidToModel: NgbDateStruct;
    public RemindDateModel: NgbDateStruct;
    public CancelLatestModel: NgbDateStruct;

    public Ramavtal: boolean;

    public ContractTagWords: any[] = [];
    public Status: number;
    public UserId: number;

    public TenantId: number;
    public Tenant: any

    public Logs: any[] = [];
    ChangedById: number;
}

export class LegalHolderModel {

    public Id: number;
    public LegalHolder: string;
    public AccountId: number;
    public IsActive: boolean;
}

export class ContractRoleModel {

    public Id: number;
    public RoleName: string;
    public AccountId: number;

}

export class OpponentModel {
    public Id: number;
    public OpponentHolderName: string;
    public AccountId: number;
}
export class ContractCategoryModel {
    public Id: number;
    public CategoryName: string;
    public CategoryDescription: string;
    public GroupId: number;
    public IsActive: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/contractModel.ts